import { Box, Typography } from '@mui/material'
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop'
import React from 'react'

interface EmptyStateProps {
  statusData: {
    instagram: boolean
    youtube: boolean
    reddit: boolean
  }
}

export default function EmptyState({
  statusData,
}: EmptyStateProps): JSX.Element {
  const scrapingText =
    "We're fetching campaign results, please check back in 2 minutes."
  const emptyStateText =
    "Try adjusting your filter to find what you're looking for"
  return (
    <Box
      sx={{
        textAlign: 'center',
        padding: '40px 20px',
        backgroundColor: '#1A1A1A',
        borderRadius: '16px',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-2px)',
        },
      }}
    >
      <ScreenSearchDesktopIcon
        sx={{
          fontSize: '84px',
          color: '#4B5563',
          opacity: 0.9,
          marginBottom: '8px',
        }}
      />
      <Typography
        variant="h4"
        sx={{
          color: '#E4E4E7',
          fontSize: '24px',
          fontWeight: '600',
          letterSpacing: '0.3px',
          marginBottom: '4px',
        }}
      >
        No results found
      </Typography>
      <Typography
        sx={{
          color: '#A1A1AA',
          fontSize: '16px',
          maxWidth: '400px',
          margin: '0 auto',
          lineHeight: 1.6,
          letterSpacing: '0.2px',
          '& span': {
            display: 'inline-block',
            animation:
              statusData.instagram || statusData.reddit || statusData.youtube
                ? 'pulse 2s infinite'
                : 'none',
          },
          '@keyframes pulse': {
            '0%': { opacity: 1 },
            '50%': { opacity: 0.6 },
            '100%': { opacity: 1 },
          },
        }}
      >
        <span>
          {statusData.instagram || statusData.reddit || statusData.youtube
            ? scrapingText
            : emptyStateText}
        </span>
      </Typography>
    </Box>
  )
}
